module.exports = __webpack_public_path__ + "static/media/Varying-origins.6160385e.png";